import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 斯美尔列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	smileToken() {
		return request({
	    url: baseUrl + '/Smile/getToken',
	    method: 'GET'
	  })
	},
	/**
	 * 斯美尔列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	smileList( params={} ) {
		return request({
	    url: baseUrl + '/Smile/deviceList',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 路灯添加
	**/
	smileAdd(data){
		return request({
			url: baseUrl + '/Smile/deviceList',
			method:'POST',
			data
		})
	},
	/**
	 * 斯美尔编辑
	**/
	smileEdit(id,data){
		return request({
			url: baseUrl + '/Smile/deviceList/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * 斯美尔删除
	**/
	smileDel(id){
		return request({
			url: baseUrl + '/Smile/deviceList/'+id,
			method:'DELETE'
		})
	}
}